import { createIcon } from "@chakra-ui/icons";

// Created from mIconRaster.svg (part of QGIS icons)

export const RasterIcon = createIcon({
  displayName: "RASTER",
  viewBox: "0 0 16 17",
  path: (
    <g id="raster">
      <path d="M6.33301 2.80005H10.667V7.13305H6.33301V2.80005Z" fill="#AEC7E2" />
      <path
        d="M2 2.80005H6.333V7.13305H2V2.80005ZM6.333 7.13305H10.667V11.467H6.333V7.13305ZM10.667 2.80005H15V7.13305H10.667V2.80005Z"
        fill="#2B3B4D"
      />
      <path
        d="M2 7.13306H6.333V11.4671H2V7.13306ZM10.667 7.13306H15V11.4671H10.667V7.13306ZM6.333 11.4671H10.667V15.8001H6.333V11.4671Z"
        fill="#AEC7E2"
      />
      <path d="M2 11.467H6.333V15.8H2V11.467Z" fill="#2B3B4D" />
    </g>
  ),
});
